import { useMutation } from 'react-query';

import { updateRiskProperty as mutationFn } from 'api/endPoints/updateRiskProperty';

export const useMutationUpdateRiskProperty = () => {
    return useMutation<string, QueryError, QueryParams>({
        mutationFn: (params) => mutationFn(params),
    });
};

export interface QueryParams {
    id: number;
    status?: 'NEW' | 'OPEN' | 'CLOSED';
    assignee?: string;
}
